import React from 'react';
import { IoMdArrowRoundBack as Arrow } from 'react-icons/io';

export default ({ count=0, goBack = ()=>{} }) => {
  return (
    <div className="Cart-Heading">

      <div className="Back-Button" onClick={() => goBack()}>
        <Arrow className='icon'/>
        <span>Continue Shopping</span>
      </div>

      <div className="Section-Title">
        Your Shopping Cart <span>({count} Items)</span>
      </div>

    </div>
  )
}
